export const yarnTypes = ["Krea Delux"];
